import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// 🔥 Your Firebase config (replace with your real values)
const firebaseConfig = {
    apiKey: "AIzaSyDTJZzIcaCarewpq38_S3cdm1EFpT_sSoI",
    authDomain: "skillaurainstitute.firebaseapp.com",
    projectId: "skillaurainstitute",
    storageBucket: "skillaurainstitute.firebasestorage.app",
    messagingSenderId: "382474590500",
    appId: "1:382474590500:web:5fd552b377135bee0d7bb1",
    measurementId: "G-JSVZG76736"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Services
export const auth = getAuth(app);
export const db = getFirestore(app);